import './SignIn.scss';

import { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import { TENANT_PHYSIOHUB, TENANT_CLIENT1PREFIX, isCapacityTenant } from './amplify/s3/storage';


const SignIn = (props: {
    tenant: string,
    unauthorizedReason: string | null,
    handleSignIn: any,
    handleFederatedSignIn: any,
}) => {
    const [signOutReason, setSignOutReason] = useState<string | null>(null);
    const isCapacity = isCapacityTenant(props.tenant);
    const isClient1Prefix = props.tenant === TENANT_CLIENT1PREFIX;
    const isPhysioHub = props.tenant === TENANT_PHYSIOHUB;

    useEffect(() => {
        const reason = localStorage.getItem('signOutReason');
        if (reason) {
            setSignOutReason(reason);
            localStorage.removeItem('signOutReason'); // Clean up after displaying
        }
    }, []);

    return (
        <Container fluid>
            <Col className='d-flex align-items-center justify-content-center'>
                <Card style={{marginTop: 50, marginBottom: 50, width: '600px'}} className='p-5'>
                    <img
                        alt="Capacity Health"
                        src={props.tenant === TENANT_PHYSIOHUB ? "/logo-stanford.png" : "/logo-capacity.svg"}
                        style={{objectFit: 'contain', width: '100%', height: '50px'}}
                    />
                    {
                        signOutReason && (
                            <Alert variant='danger' className='mt-4'>
                                {signOutReason}
                            </Alert>
                        )
                    }
                    {
                        props.unauthorizedReason && (
                            <Alert variant='danger' className='mt-4'>
                                <strong>Unauthorized.</strong> {props.unauthorizedReason}
                            </Alert>
                        )
                    }
                    {/* Capacity tenants: Only Google */}
                    {isCapacity && (
                        <Row className='mt-4'>
                            <Button variant='secondary' onClick={() => props.handleFederatedSignIn('Google')} style={{height: '48px'}}>
                                Sign In with Google
                            </Button>
                        </Row>
                    )}

                    {/* Client1Prefix tenant: Only SUNetID */}
                    {isClient1Prefix && (
                        <Row className='mt-4'>
                            <Button variant='secondary' onClick={() => props.handleFederatedSignIn('Stanford')} style={{height: '48px'}}>
                                Sign In with SUNetID <img src='/stanford-block-white.png' height='20' style={{marginRight: '12px', marginTop: '-4px'}} />
                            </Button>
                        </Row>
                    )}

                    {/* PhysioHub tenant: SID or SUNetID */}
                    {isPhysioHub && (
                        <>
                            <Row className='mt-4'>
                                <Button variant='secondary' onClick={() => props.handleFederatedSignIn('StanfordHealthCare')} style={{height: '48px'}}>
                                    Sign In with SID <img src='/stanford-healthcare-white.svg' height='20' style={{marginLeft: '12px', marginRight: '12px', marginTop: '-4px'}} />
                                </Button>
                            </Row>
                            <Row className='mt-4'>
                                <p className='strike-through-text'><span>OR</span></p>
                            </Row>
                            <Row className='mt-4'>
                                <Button variant='outline-secondary' onClick={() => props.handleFederatedSignIn('Stanford')} style={{height: '48px'}}>
                                    Sign In with SUNetID <img src='/stanford-block-white.png' height='20' style={{marginRight: '12px', marginTop: '-4px'}} />
                                </Button>
                            </Row>
                        </>
                    )}
                    {/* <Row className='mt-4'>
                        <p className='strike-through-text'><span>OR</span></p>
                    </Row>
                    <Row className='mt-4'>
                        <SignInForm onSignIn={props.handleSignIn} />
                    </Row> */}
                </Card>
            </Col>
        </Container>
    )
}

function SignInForm({ onSignIn }: any) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e: any) => {
        e.preventDefault();
        onSignIn(username, password);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Control size='lg' type="email" placeholder="Email" onChange={(e) => setUsername(e.target.value)} />
            </Form.Group>
            <Form.Group className="mb-3">
                <Form.Control size='lg' type="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
            </Form.Group>
            <div className="d-grid gap-2">
                <Button variant="outline-secondary" type="submit">Sign In With Email</Button>
            </div>
        </Form>
    );
}

export default SignIn;
